import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Survey from '@/models/Survey.js'

export const useSurveyStore = defineStore('surveyStore', () => {
  let syncableModel = useSyncableModel(useApiResource('surveys'), {
    className: Survey.modelName.name,
    paramKey: Survey.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
